import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4118a552"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.visible,
    onClose: _ctx.handleCancel,
    "close-on-click-modal": false,
    onOpen: _ctx.handleOpen,
    width: "700px",
    title: _ctx.regionId ? '编辑销售区域绑定' : '创建销售区域绑定',
    "custom-class": "el-dialog-inner-scroll"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_button, { onClick: _ctx.handleCancel }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.handleSubmit
        }, {
          default: _withCtx(() => [
            _createTextVNode("提交")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        model: _ctx.form,
        "label-width": "100px",
        ref: "formRef"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "区域编码",
            prop: "regionCode",
            rules: [
          {
            required: true,
            message: '请选择区域编码',
            trigger: ['blur'],
          },
        ]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.form.regionCode,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.regionCode) = $event)),
                placeholder: "请选择区域编码",
                style: {"width":"100%"},
                onChange: _ctx.handleSelectRegion,
                disabled: !!_ctx.regionId
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.regionCodeList, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item,
                      label: item.value + '（'+item.valueCode+'）',
                      value: item.valueCode
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "onChange", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "区域名称",
            prop: "regionName",
            rules: [
          {
            required: true,
            message: '请输入区域名称',
            trigger: ['blur'],
          },
        ]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                placeholder: "请输入区域名称",
                modelValue: _ctx.form.regionName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.regionName) = $event)),
                disabled: "",
                maxlength: "100"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "所属地区",
            prop: "regionInfoList",
            rules: [
          {
            type: 'array',
            required: true,
            message: '请输入选择区域',
            trigger: 'change',
          },
        ]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                placeholder: "请选择所属地区",
                modelValue: _ctx.region,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.region) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_tree, {
                props: _ctx.props,
                "node-key": "code",
                ref: "treeRef",
                "default-checked-keys": _ctx.checkedKeys,
                "default-expanded-keys": _ctx.expandedKeys,
                data: _ctx.provinceCityAreaList,
                "show-checkbox": "",
                onCheck: _ctx.handleCheck
              }, null, 8, ["props", "default-checked-keys", "default-expanded-keys", "data", "onCheck"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["modelValue", "onClose", "onOpen", "title"]))
}